import { component } from 'picoapp'

export default component((node, ctx) => {
  console.log('swatch init')
  const swatchWrapper = node.querySelector('.swatches');
  const swatches = swatchWrapper.querySelectorAll('.square_swatch:not(.free-swatch)');
  const multiSwatches = swatchWrapper.querySelectorAll('.free-swatch');
  let replaceImg = document.querySelector('.product-images img');
  const swatchSender = document.querySelector('.js-input-swatch');
  let swatchTitle = document.querySelector('.js-active-swatch');
  let array = [];
  const ifSwatches = document.querySelector('.see-swatches');
  const terms = document.querySelector('#Terms');
  const addToCart = document.querySelector('.js-add-to-cart');

  multiSwatches.forEach(multiSwatch => {
    multiSwatch.addEventListener('click', () => {
      // check for swatch in the array
      const newItem = multiSwatch.dataset.swatch;
      array.indexOf(newItem) === -1 ? array.push(newItem) : array.splice(array.indexOf(newItem), 1);
      
      // update the parent wrapper to toggle active border
      multiSwatch.parentElement.classList.contains('active') ? multiSwatch.parentElement.classList.remove('active') : multiSwatch.parentElement.classList.add('active');

      // update the swatch title on the UI
      swatchTitle.innerHTML = array.join(', ');

      // send to the cart (swatch sender)
      swatchSender.value = array.join(', ');

      // swap the main image
      const toImage = multiSwatch.dataset.switch;
      replaceImg.src = toImage;
      console.log(toImage + 'into ' + replaceImg);
    })
  });

  // confirm at least one fabric is selected (reminder)
  if (ifSwatches) {
    console.log(array)
    terms.addEventListener('click', function(evt) {
      console.log(terms)
      console.log(addToCart.getAttribute('disabled'))

      if (array.length === 0) {
        alert('Please be sure to select the color swatches you want us to include');
      }
    })
  }


  // initial value - not for multiple selections
  if (swatches[0]) {
    swatchSender.value = swatches[0].dataset.swatch;
    swatchTitle.innerHTML = swatches[0].dataset.swatch;
  }

  // when they select a swatch update the sender
  for (let i = 0; i < swatches.length; i++) {
    const swatch = swatches[i];

    // on click
    swatch.addEventListener('click', function() {
      // remove active from all
      for (let i = 0; i < swatches.length; i++) {
        const els = swatches[i];
        els.parentElement.classList.remove('active');
      }

      // add the class to the clicked elem
      swatch.parentElement.classList.add('active');

      // add to the swatch sender
      swatchSender.value = swatch.dataset.swatch;
      swatchTitle.innerHTML = swatch.dataset.swatch;
      console.log(swatchSender)
    }) 
  }



  const addOrRemove = (array, item) => {
    const exists = array.includes(item)
  
    if (exists) {
      return array.filter((c) => { return c !== item })
    } else {
      const result = array
      result.push(item)
      return result
    }
  }

})